<style lang="sass">
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
@import sass/link
@import sass/btn
@import sass/btnRound
</style>
<script>
import Vue from 'vue'
import dataLayer from 'nespresso-library/src/core/dataLayer'
import Tracking from 'nespresso-library/src/core/tracking'

const LINK_CLASS = 'g_link'
const BUTTON_CLASS = 'g_btn'
const BUY_CLASS = 'g_btnBuy'
const GOLD_CLASS = 'g_btnGold'
const WHITE_CLASS = 'g_btnWhite'
const OUTLINE_CLASS = 'g_btnOutline'
const TXT_CLASS = 'g_txt_'
const TXT_SIZES = ['XS', 'S', 'M', 'L', 'XL']
const HEADLINE_CLASS = 'g_headline'

export default {
    name: 'cta',
    props: {
        size: {
            type: String,
            validator (value) {
                return !!~TXT_SIZES.indexOf(value)
            }
        },
        sizeMobile: {
            type: String,
            validator (value) {
                return !!~TXT_SIZES.indexOf(value)
            }
        },
        isLink: Boolean,
        isBtn: Boolean,
        isWhite: Boolean,
        isGold: Boolean,
        isBuy: Boolean,
        isOutline: Boolean,
        isHeadline: Boolean,
        link: String,
        linkMobile: String,
        scrollTo: String,
        type: {
            type: String,
            required: true,
            validator: function (value) {
                return !!~['text', 'button'].indexOf(value)
            }
        },
        classNameContent: {},
        fontIcon: String,
        content: String,
        trackingLabel: String,
        target: {
            type: String
        }
    },
    methods: {
        handleClick (evt) {
            this.$emit('click')
            // Run scroll to element

            if (this.scrollTo) {
                import(/* webpackChunkName: "scrollTo" */ 'nespresso-library/src/utils/scrollTo').then(goToAnchor => {
                    const [anchor, duration] = this.scrollTo.split(',')
                    goToAnchor.default(anchor[0] !== '#' ? '#' + anchor : anchor, parseInt(duration))

                    this.trackLink()
                })
            } else if (this.link) {
                evt.preventDefault()

                this.trackLink()
                this.goToLink()
            }
        },
        goToLink () {
            if (!this.target) {
                location.href = this.getLink()
            } else {
                window.open(this.getLink(), this.target)
            }
        },
        trackLink () {
            if (this.trackingLabel) {
                Tracking.customEvent({
                    category: 'User Engagement',
                    action: 'Click',
                    label: `${this.$landing.trackingLabelPrefix} - CTA - ${this.trackingLabel}`,
                    interaction: 0
                })
            }
        },
        hasIcon () {
            return this.icon || this.fontIcon
        },
        getLink () {
            return dataLayer.isMobile && this.linkMobile !== '' ? this.linkMobile : this.link
        }
    },
    beforeMount () {
        if (this.hasIcon()) {
            Vue.component('Visual', () => import(/* webpackChunkName: "Visual" */ '../Visual').then(m => m.default))
        }
    },
    render (createElement) {
        let size = this.size
        const classNames = []
        const attrs = {}
        let el

        if (this.type === 'button') {
            el = 'button'
        } else {
            el = 'a'
            attrs.href = this.getLink()
            if (this.target) {
                attrs.target = this.target
            }
        }

        if (this.sizeMobile && this.$breakpoint.isS) {
            size = this.sizeMobile
        }
        if (size && !this.isHeadline) {
            classNames.push(TXT_CLASS + size)
        }

        if (this.isWhite) {
            classNames.push(BUTTON_CLASS)
            classNames.push(WHITE_CLASS)
        } else if (this.isGold) {
            classNames.push(BUTTON_CLASS)
            classNames.push(GOLD_CLASS)
        } else if (this.isBuy) {
            classNames.push(BUTTON_CLASS)
            classNames.push(BUY_CLASS)
        } else if (this.isOutline) {
            classNames.push(BUTTON_CLASS)
            classNames.push(OUTLINE_CLASS)
        } else if (this.isLink) {
            classNames.push(LINK_CLASS)
        } else if (this.isBtn) {
            classNames.push(BUTTON_CLASS)
        }

        const classNamesContent = []
        if (this.isHeadline) {
            classNamesContent.push(HEADLINE_CLASS)
        }

        if (this.classNameContent) {
            classNamesContent.push(this.classNameContent)
        }

        let span
        if (this.content) {
            span = createElement('span',
                {
                    attrs: {
                        class: classNamesContent
                    },
                    domProps: {
                        innerHTML: this.content
                    }
                }
            )
        }

        let fontIcon
        if (this.fontIcon) {
            fontIcon = createElement('Visual',
                {
                    attrs: {
                        fontIcon: this.fontIcon,
                        'aria-hidden': true
                    }
                }
            )
        }

        return createElement(el,
            {
                class: classNames,
                attrs,
                on: {
                    click: evt => this.handleClick(evt)
                }
            },
            [this.$slots.default, span, fontIcon, this.$slots.after]
        )
    }
}
</script>
